import styled from 'styled-components';
import { themeOptions } from 'styles/theme';

export const StyledBasicSelect = styled.div`
  margin-bottom: ${(props) =>
    props['className'] === 'equipment-select' || props['className'] === 'status-select'
      ? '0'
      : '20px'};
  text-align: left;

  span {
    font-weight: 600;

    &.placeholder {
      font-weight: 400;
      color: #adadad;
    }
  }

  && {
    .MuiInputBase-root {
      padding-right: 8px;
      height: 40px;
      width: ${(props) => (props.width ? props.width : null)};
      border-radius: 6px;
      border: 1px solid ${themeOptions.palette.gray.border};
      background-color: ${themeOptions.palette.white.main};

      &:hover {
        box-shadow: 0 0 0 3px var(--color-off-white);
        .MuiOutlinedInput-notchedOutline {
          border: 1px solid ${themeOptions.palette.gray.border};
        }
      }
    }
    .MuiSelect-select {
      padding: 0 0 0 6px;
      width: ${(props) => (props.width ? props.width : null)};
      border-radius: 6px;
      box-sizing: border-box;
      background-color: ${themeOptions.palette.white.main};

      p {
        display: flex;
        align-items: center;
        color: ${themeOptions.palette.gray.dark};
      }
    }
    .MuiOutlinedInput-notchedOutline {
      border: 1px solid #dadada;
      padding-right: 8px;
    }
    .Mui-focused {
      .MuiOutlinedInput-notchedOutline {
        border-width: 1px;
      }
    }

    .MuiPaper-root {
      box-shadow: 0px 4px 10px 0px #0000001a;
      border: 1px solid #dadada;
      border-radius: 6px;
      .MuiList-root {
        padding: 5px;
        .MuiButtonBase-root {
          height: 40px;
          border-radius: 4px;
        }
        &.Mui-selected {
          background-color: ${themeOptions.palette.green.main} !important;
        }
      }
    }

    .required {
      margin-right: 0 !important;
    }

    /* required 경우, disabled style */
    .MuiOutlinedInput-root.Mui-disabled {
      background-color: ${themeOptions.palette.gray.light};
    }
  }
`;
